module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_troms_og_finnmark_neg.0b2718f5.pdf";